import React from 'react'
import "./Faq_banner.css"

function Faq_banner() {
  return (
   <section className='Faq_banner'>
    <div className='img_holder'>
        <img src='/assest/luxury_images/support/faq/faq_banner/faq_banner.png' alt='Faq banner' className='Faq_banner_img'/>
    </div>
   </section>
  )
}

export default Faq_banner